import React from "react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";

const UserCard = ({ user, onEdit, onDelete, add, setIsOpenCallback }) => {
  if (add) {
    return (
      <div
        className="group_card cursor_pointer d_flex justify_center"
        onClick={() => setIsOpenCallback(true)}
        style={{ background: "var(--builder-bg)", alignItems: "center" }}
      >
        <MaterialIcon name="add" style={{ fontSize: "20px" }} />
        <h3>Add New User</h3>
      </div>
    );
  }

  return (
    <div className="group_card">
      <div className="group_heading_outer">
        <strong>
          {" "}
          <span className="group_heading">{user.name}</span>
        </strong>
        <div className="group_action_buttons">
          <MaterialIcon
            name="edit"
            className="builder_action_btn"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(user);
            }}
          />
          <MaterialIcon
            name="delete"
            className="builder_action_btn delete"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(user.user_id, user.name);
            }}
          />
        </div>
      </div>
      <span className="group_description">{user.description}</span>
    </div>
  );
};

export default UserCard;
